import React, { useContext } from 'react';
import css from './index.module.scss';
import { SectionContext } from '../../context';
import { NavLink } from '../NavLink';

export interface SectionTrackerProps {
  sectionTitles?: string[];
}

export const SectionTracker = (props: SectionTrackerProps) => {
  const sectionContext = useContext(SectionContext);

  return (
    <aside className={css.container}>
      <ul className={css.list}>
        {props.sectionTitles?.map((sectionTitle, index) => (
          <NavLink
            key={sectionTitle}
            onClick={() => sectionContext.scrollToIndex(index)}
            isActive={sectionContext.activeSectionIndex === index}
            className={css.item}
            vertical
          >
            {sectionTitle}
          </NavLink>
        ))}
      </ul>
    </aside>
  );
};
